import { getPagePath, trans } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_GRACE_PERIOD_CANCELLATION_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import Link from '../Link';

import { DSIcon } from '../../../base';

import styles from './GracePeriodCancellationModal.module.scss';

const GracePeriodCancellationModal = () => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_GRACE_PERIOD_CANCELLATION_MODAL
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size="normal"
      className={styles['grace-period-cancellation-modal']}
    >
      <ModalHeader
        className={styles['grace-period-cancellation-modal__header']}
        onRequestClose={handleModalClose}
        label={
          <>
            <DSIcon name="history" size="ml" />
            <br />
            {trans(
              'property_show.book_now_card.grace.period.cancellation.title'
            )}
          </>
        }
      />
      <ModalBody className={styles['grace-period-cancellation-modal__body']}>
        <p>{trans('grace-period.modal.description')}</p>

        <div>
          <h5
            className={
              styles['grace-period-cancellation-modal__conditions-title']
            }
          >
            {trans('grace-period.modal.conditions1')}
          </h5>
          <ul
            className={
              styles['grace-period-cancellation-modal__conditions-list']
            }
          >
            <li>{trans('grace-period.modal.conditions1.item1')}</li>
            <li>{trans('grace-period.modal.conditions1.item2')}</li>
          </ul>
        </div>

        <div>
          <h5
            className={
              styles['grace-period-cancellation-modal__conditions-title']
            }
          >
            {trans('grace-period.modal.conditions2')}
          </h5>
          <p>{trans('grace-period.modal.conditions2.item1')}</p>
        </div>

        <Link
          href={getPagePath('help-center.cancellation-policies')}
          target="_blank"
          className={styles['grace-period-cancellation-modal__cta']}
        >
          {trans('grace-period.modal.cta')}
        </Link>
      </ModalBody>
    </Modal>
  ) : null;
};

export default GracePeriodCancellationModal;
